import React from 'react';
import FeatureComponent from '../components/Home/Features';
import IndustryIcons from '../components/Home/IndustryIcons';
const Features = () => (
  <div
    id="features-section"
    className="bg-gradient-to-br from-white via-[#f8fafc] to-[#e6fffa] min-h-[60vh]">
    {/* If you have a FeatureComponent that renders cards, just place it here */}
    <div className="mt-10 mb-10">
      <FeatureComponent from={'Features'} />
    </div>
    <div className="mt-10 mb-10">
      <IndustryIcons from="mainFeature" />
    </div>
  </div>
);

export default Features;
